import { useMutation, useQueryClient } from "react-query";
import { updateActionState } from "@/services/tasks";
/** Mutation hook to record the result state of an action after the FE performs it. Refetches the action center so the state persists across reopen. */
export function useUpdateActionState(patientUid, reminderId) {
  var queryClient = useQueryClient();
  return useMutation(function (_ref) {
    var actionId = _ref.actionId,
      state = _ref.state;
    return updateActionState(patientUid, reminderId, actionId, state);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(["action-center", patientUid, reminderId]);
    },
    onError: function onError() {}
  });
}